// 23 European languages supported via auto-translation.
// English is the source of truth — all other languages are translated by
// our AI engine on first request and cached in MongoDB.
export const SUPPORTED_LANGUAGES = [
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "nl", name: "Nederlands", flag: "🇳🇱" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "it", name: "Italiano", flag: "🇮🇹" },
  { code: "pt", name: "Português", flag: "🇵🇹" },
  { code: "pl", name: "Polski", flag: "🇵🇱" },
  { code: "sv", name: "Svenska", flag: "🇸🇪" },
  { code: "da", name: "Dansk", flag: "🇩🇰" },
  { code: "fi", name: "Suomi", flag: "🇫🇮" },
  { code: "no", name: "Norsk", flag: "🇳🇴" },
  { code: "el", name: "Ελληνικά", flag: "🇬🇷" },
  { code: "cs", name: "Čeština", flag: "🇨🇿" },
  { code: "ro", name: "Română", flag: "🇷🇴" },
  { code: "hu", name: "Magyar", flag: "🇭🇺" },
  { code: "sk", name: "Slovenčina", flag: "🇸🇰" },
  { code: "bg", name: "Български", flag: "🇧🇬" },
  { code: "hr", name: "Hrvatski", flag: "🇭🇷" },
  { code: "sl", name: "Slovenščina", flag: "🇸🇮" },
  { code: "et", name: "Eesti", flag: "🇪🇪" },
  { code: "lv", name: "Latviešu", flag: "🇱🇻" },
  { code: "lt", name: "Lietuvių", flag: "🇱🇹" },
];

export const LANGUAGE_NAMES = Object.fromEntries(
  SUPPORTED_LANGUAGES.map((l) => [l.code, l.name]),
);

export const LANGUAGE_FLAGS = Object.fromEntries(
  SUPPORTED_LANGUAGES.map((l) => [l.code, l.flag]),
);

// Mapping language code → human label sent to the AI engine for translation prompts.
export const LANGUAGE_FULL_NAMES = {
  en: "English",
  nl: "Dutch (Nederlands)",
  de: "German (Deutsch)",
  fr: "French (Français)",
  es: "Spanish (Español)",
  it: "Italian (Italiano)",
  pt: "Portuguese (Português)",
  pl: "Polish (Polski)",
  sv: "Swedish (Svenska)",
  da: "Danish (Dansk)",
  fi: "Finnish (Suomi)",
  no: "Norwegian (Norsk Bokmål)",
  el: "Greek (Ελληνικά)",
  cs: "Czech (Čeština)",
  ro: "Romanian (Română)",
  hu: "Hungarian (Magyar)",
  sk: "Slovak (Slovenčina)",
  bg: "Bulgarian (Български)",
  hr: "Croatian (Hrvatski)",
  sl: "Slovenian (Slovenščina)",
  et: "Estonian (Eesti)",
  lv: "Latvian (Latviešu)",
  lt: "Lithuanian (Lietuvių)",
};
